import type { PluginContainerData } from './../ricos-schema/legacy/wix/rich_content/v1';
import {
  Node_Type,
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type,
} from './../ricos-schema/legacy/wix/rich_content/v1';

export const DEFAULTS = Object.freeze({
  config: {
    alignment: 'center',
    size: 'content',
    showTitle: true,
    showDescription: true,
  },
});

export const RICOS_DEFAULTS: { containerData: PluginContainerData } = Object.freeze({
  containerData: {
    alignment: PluginContainerData_Alignment.CENTER,
    width: {
      size: PluginContainerData_Width_Type.CONTENT,
    },
    textWrap: true,
  },
});

export const PLUGIN_TOOLBAR_BUTTON_ID_IMAGE_EDITOR = 'image-editor';

export const IMAGE_SETTINGS_MODAL_ID = 'IMAGE.settings';
export const IMAGE_EDITOR_MODAL_ID = 'IMAGE.imageEditor';
export const IMAGE_EDITOR_COLOR_PICKER_MODAL_ID = 'IMAGE.imageEditor.colorPicker';

export const IMAGE_BUTTONS = {
  size: `${Node_Type.IMAGE}.size`,
  alignment: `${Node_Type.IMAGE}.alignment`,
};

export const DEFAULT_PALETTE = [
  '#FFFFFF',
  '#D5D4D4',
  '#ABCAFF',
  '#81B0FF',
  '#0261FF',
  '#0141AA',
  '#012055',
  '#000000',
];
